import React, { useState, useEffect, useRef, useCallback } from "react";
import Preview from "../../dasboard-component/MainDashboard.jsx";
import styles from "./AdminDashboard.module.css";
import PreviewArena from "../../ArenaManagementSystem/arena_user_dashboard/Main_user_dash.jsx";
import PreviewArenaDetail from "../../ArenaManagementSystem/arena_user_dashboard/ArenaDetails.jsx";
import PreviewNewsHome from "../../dasboard-component/AllNews.jsx";
import PreviewNewsDetail from "../../dasboard-component/NewsDetails.jsx";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import AdminHeader from "./AdminHeader";

// Leaflet icon setup
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const containerStyle = {
  width: "100%",
  height: "300px",
};

const center = [0, 0];

const SetViewOnClick = ({ coords, shouldPan }) => {
  const map = useMap();
  useEffect(() => {
    if (shouldPan && coords[0] !== 0 && coords[1] !== 0) {
      map.setView(coords, 13);
    }
  }, [coords, map, shouldPan]);
  return null;
};

const MapEvents = ({ onMapClick }) => {
  useMapEvents({
    click: onMapClick,
  });
  return null;
};

const AdminDashboard = () => {
  const [adType, setadType] = useState(null);
  const [adButton, setAdButton] = useState(null);
  const [mapCenter, setMapCenter] = useState([0, 0]);
  const [marker, setMarker] = useState(null);
  const [shouldPan, setShouldPan] = useState(false);
  const mapRef = useRef(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [mediaPreview, setMediaPreview] = useState(null);
  const [mediaType, setMediaType] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [parentInfo, setParentInfo] = useState({
    company_name: "",
    agency_name: "",
    company_phone: "",
    agency_phone: "",
    url: "",
    image: null,
    video: null,
    text: "",
    content: "",
    slotPlace: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    intervals: "5 sec",
    total_time: "",
    original_iter: 0,
    iterations: 0,
    clicks: 0,
    house_number: "",
    street_number: "",
    area: "",
    city: "",
    country: "",
    coordinates: "",
  });
  const slotPlaceOptions = [
    { value: "landingPage", label: "landingPage" },
    { value: "arenaHomePage", label: "arenaHomePage" },
    { value: "arenaDetailPage", label: "arenaDetailPage" },
    { value: "newsHomePage", label: "newsHomePage" },
    { value: "newsDetailPage", label: "newsDetailPage" },
  ];
  const [selectedPage, setSelectedPage] = useState(slotPlaceOptions[0].value);

  const handleParentInputChange = (e) => {
    const { name, value } = e.target;
    setParentInfo({ ...parentInfo, [name]: value });
  };
  const navigate = useNavigate();
  const handleBack = () => {
    if (adType) {
      setadType(null);
      setParentInfo({
        company_name: "",
        agency_name: "",
        company_phone: "",
        agency_phone: "",
        url: "",
        image: null,
        video: null,
        text: "",
        content: "",
        slotPlace: "",
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
        intervals: "5 sec",
        total_time: "",
        original_iter: 0,
        iterations: 0,
        clicks: 0,
        house_number: "",
        street_number: "",
        area: "",
        city: "",
        country: "",
        coordinates: "",
      });
      setMediaPreview(null);
    }
    if (!adType && adButton) {
      setAdButton(null);
    }
  };

  const [error, setError] = useState("");

  const geocodeAddress = useCallback(async () => {
    const { house_number, street_number, area, city, country } = parentInfo;
    const address =
      `${house_number} ${street_number}, ${area}, ${city}, ${country}`.trim();
    if (!address) return;

    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search`,
        {
          params: {
            q: address,
            format: "json",
            limit: 1,
            addressdetails: 1,
          },
        }
      );

      if (response.data.length > 0) {
        const { lat, lon, address: details } = response.data[0];
        setMapCenter([parseFloat(lat), parseFloat(lon)]);
        setMarker([parseFloat(lat), parseFloat(lon)]);
        setShouldPan(true);
        setParentInfo((prevData) => ({
          ...prevData,
          house_number: details.house_number || prevData.house_number,
          street_number: details.road || prevData.street_number,
          area: details.suburb || prevData.area,
          city: details.city || details.town || prevData.city,
          country: details.country || prevData.country,
          coordinates: `${lat}, ${lon}`,
        }));
        setError("");
      } else {
        setError("No location found for this address");
      }
    } catch (error) {
      console.error("Error geocoding:", error);
      setError("Error finding location");
    }
  }, [parentInfo]);

  const handleMapClick = useCallback(async (e) => {
    const { lat, lng } = e.latlng;
    setMarker([lat, lng]);
    setMapCenter([lat, lng]);
    setShouldPan(true);
    setParentInfo((prevData) => ({
      ...prevData,
      coordinates: `${lat}, ${lng}`,
    }));

    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse`,
        {
          params: {
            lat: lat,
            lon: lng,
            format: "json",
            addressdetails: 1,
          },
        }
      );

      if (response.data) {
        const { address } = response.data;
        setParentInfo((prevData) => ({
          ...prevData,
          house_number: address.house_number || "",
          street_number: address.road || "",
          area: address.suburb || address.neighbourhood || address.county || "",
          city: address.city || address.town || "",
          country: address.country || "",
          coordinates: `${lat}, ${lng}`,
        }));
        setError("");
      } else {
        setError("No address found for this location");
      }
    } catch (error) {
      console.error("Error reverse geocoding:", error);
      setError("Error fetching address information");
    }
  }, []);

  const MapEvents = () => {
    useMapEvents({
      click: handleMapClick,
      dragstart: () => setShouldPan(false),
      zoomstart: () => setShouldPan(false),
    });
    return null;
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (adType === "image") {
      setParentInfo({ ...parentInfo, image: file });
    } else if (adType === "video") {
      setParentInfo({ ...parentInfo, video: file });
    }

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setMediaPreview(reader.result);
        setMediaType(file.type.startsWith("image") ? "image" : "video");
      };
      reader.readAsDataURL(file);
    }
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!(file instanceof Blob)) {
        console.error("Invalid file object:", file);
        reject(new Error("Invalid file object"));
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const extractDuration = (inter) => {
    if (typeof inter !== "string") return;
    if (inter === null || inter === undefined || inter === "") inter = "5 sec";
    const match = inter.match(/\d+/);
    return match ? parseInt(match[0]) * 1000 : 5000;
  };

  const selectTheSlot = (slot) => {
    setSelectedSlot(slot);
  };

  const handleSubmit = async (e) => {
    if (e.submitter && e.submitter.type !== "submit") {
      e.preventDefault();
    }
    e.preventDefault();
    if (!selectedSlot) {
      alert("Please select the slot");
      return;
    }
    parentInfo.intervals = extractDuration(parentInfo.intervals);
    parentInfo.slotPlace = selectedPage + " " + selectedSlot.split("-")[1];
    if (
      !isStartTimeBeforeEndTime(
        parentInfo.start_date,
        parentInfo.start_time,
        parentInfo.end_date,
        parentInfo.end_time
      )
    )
      alert("Time and Date not correct");
    else {
      try {
        const jsonData = {
          ...parentInfo,
        };

        // Convert File objects to base64 strings
        if (jsonData.image && jsonData.image instanceof File) {
          jsonData.image = await fileToBase64(jsonData.image);
        } else {
          console.warn("this is not a File object:", jsonData.image);
        }

        if (jsonData.video && jsonData.video instanceof File) {
          jsonData.video = await fileToBase64(jsonData.video);
        } else {
          console.warn("this is not a File object:", jsonData.video);
        }

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/upload-ad`,
          jsonData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data && response.data.success) {
          alert(response.data.message || "Advertisement Uploaded successfully");
          navigate("/advertisement-admin");
        } else {
          throw new Error(
            response.data.message || "Failed to upload advertisement"
          );
        }
      } catch (error) {
        console.error("Error uploading advertisement:", error);
        alert("Failed to upload advertisement: " + error.message);
      }
    }
  };

  const options = [
    { value: "5 sec", label: "5 sec" },
    { value: "10 sec", label: "10 sec" },
  ];

  function isStartTimeBeforeEndTime(startDate, startTime, endDate, endTime) {
    const currentDateTime = new Date();
    const currentDate = currentDateTime.toISOString().split("T")[0];
    const startDat = startDate.split("T")[0];
    const startDateTime = new Date(startDate.split("T")[0] + "T" + startTime);
    const endDateTime = new Date(endDate.split("T")[0] + "T" + endTime);

    // const oneHourLater = new Date(currentDateTime.getTime() + 60 * 60 * 1000);

    if (startDat < currentDate || startDateTime >= endDateTime) {
      return false;
    } else {
      return true;
    }
  }

  const [ads, setAds] = useState([]);

  const fetchAds = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/download-ad`
      );
      setAds(response.data.ads);
    } catch (error) {
      console.error("Error fetching ads:", error);
    }
  };

  useEffect(() => {
    let isMounted = true;
    let timeoutId;

    const fetchAds = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/download-ad`
        );
        if (isMounted) setAds(response.data.ads);
      } catch (error) {
        console.error("Error fetching ads:", error);
      }

      if (isMounted) {
        timeoutId = setTimeout(fetchAds, 500);
      }
    };

    fetchAds();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/api/delete-ad`,
        { data: { id } }
      );
      if (response.data.success) {
        fetchAds();
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error deleting ad:", error);
      alert("Failed to delete ad. Please try again later.");
    }
  };

  function isAdCurrentlyActive(ad) {
    const currentDateTime = new Date(); // Current date and time: 2025-06-20 23:55:00 PKT
    const currentDate = currentDateTime.toISOString().split("T")[0]; // 2025-06-20
    const currentTime = currentDateTime.toTimeString().split(" ")[0]; // 23:55:00

    // Parse ad dates
    const startDate = ad.start_date.split("T")[0]; // e.g., 2025-06-20
    const endDate = ad.end_date.split("T")[0]; // e.g., 2025-06-21

    // Date range check
    if (startDate <= currentDate && currentDate <= endDate) {
      // Time range check
      const datePart = currentDate; // Use current date for time comparison
      const currentDateTimeObj = new Date(`${datePart}T${currentTime}`);
      const startDateTimeObj = new Date(`${datePart}T${ad.start_time}`);
      const endDateTimeObj = new Date(`${datePart}T${ad.end_time}`);

      return (
        startDateTimeObj <= currentDateTimeObj &&
        currentDateTimeObj <= endDateTimeObj
      );
    }

    return false;
  }

  function formatDate(dateStr) {
    const date = new Date(dateStr);

    return (
      <>
        {date.toLocaleDateString("en-US", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}
      </>
    );
  }
  function formatTime(timeStr) {
    const time = new Date(`2000-01-01T${timeStr}`);

    return (
      <>
        {time.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })}
      </>
    );
  }

  return (
    <div className={styles.dashboardContainer}>
      <AdminHeader />
      <button className={styles.backButton} onClick={handleBack}>
        ← Back &nbsp;&nbsp;
      </button>
      <form onSubmit={handleSubmit}>
        {adType && (
          <>
            <button type="submit" className={styles.submitButton}>
              Submit →
            </button>
          </>
        )}

        <div className={styles.dashboard}>
          {!adType && <h2 className={styles.title}>Admin Dashboard</h2>}
          {!adButton && (
            <div className={styles.adButtons}>
              <button onClick={() => setAdButton("upload")}>
                <i className="fa-solid fa-upload"></i> Upload Ad
              </button>
              <button onClick={() => setAdButton("watch")}>
                <i className="fa-solid fa-eye"></i> Watch Ads
              </button>
            </div>
          )}
          {!adType && adButton === "upload" && (
            <div className={styles.adButtons}>
              <button onClick={() => setadType("image")}>
                <i className="fa-solid fa-image"></i> Image Ad
              </button>
              <button onClick={() => setadType("video")}>
                <i className="fa-solid fa-video"></i> Video Ad
              </button>
              <button onClick={() => setadType("text")}>
                <i className="fa-solid fa-font"></i> Text Ad
              </button>
            </div>
          )}
        </div>
        {adType && (
          <>
            <div className={styles.MPersonaldetailSection}>
              <p
                className="MHeadings1"
                style={{ textAlign: "center", fontSize: "24px" }}
              >
                <b>Basic Info</b>
              </p>
              <div className={styles.r1}>
                <div className={styles.c1}>
                  <p>Company Name</p>
                  <input
                    type="text"
                    name="company_name"
                    className={styles.textField}
                    value={parentInfo.company_name}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
                <div className={styles.c2}>
                  <p>Marketing Agency Name</p>
                  <input
                    type="text"
                    name="agency_name"
                    className={styles.textField}
                    value={parentInfo.agency_name}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
              </div>

              <div className={styles.r1}>
                <div className={styles.c1}>
                  <p>Company Phone</p>
                  <input
                    type="text"
                    name="company_phone"
                    className={styles.textField}
                    value={parentInfo.company_phone}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
                <div className={styles.c2}>
                  <p>Marketing Agency Phone</p>
                  <input
                    type="text"
                    name="agency_phone"
                    className={styles.textField}
                    value={parentInfo.agency_phone}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
              </div>
              <div className={styles.r3}>
                <div className={styles.c1}>
                  <p>Ad Redirect url</p>
                  <input
                    type="text"
                    name="url"
                    className={styles.textField}
                    value={parentInfo.url}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
                <div className={styles.c2}>
                  {adType === "text" && (
                    <>
                      <p>Ad Title</p>
                      <input
                        type="text"
                        name="text"
                        className={styles.textField}
                        value={parentInfo.text}
                        onChange={handleParentInputChange}
                        required
                      />
                    </>
                  )}
                  {adType !== "text" && (
                    <>
                      <p>
                        Upload {adType === "video" && <>Video</>}
                        {adType === "image" && <>Image</>}
                      </p>
                      {adType === "video" && (
                        <input
                          type="file"
                          name="file"
                          className={styles.textField}
                          onChange={handleFileUpload}
                          accept="video/*"
                          required
                        />
                      )}
                      {adType === "image" && (
                        <input
                          type="file"
                          name="file"
                          className={styles.textField}
                          onChange={handleFileUpload}
                          accept="image/*"
                          required
                        />
                      )}
                      {mediaPreview && (
                        <div style={{ marginTop: "10px" }}>
                          {mediaType === "image" ? (
                            <img
                              src={mediaPreview}
                              alt="Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "5px",
                              }}
                            />
                          ) : (
                            <video
                              controls
                              src={mediaPreview}
                              style={{
                                width: "150px",
                                height: "100px",
                                borderRadius: "5px",
                              }}
                            />
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              {adType === "text" && (
                <div className={styles.r3}>
                  <div className={styles.c1}>
                    <p>Ad Content</p>
                    <textarea
                      rows={10}
                      name="content"
                      className={styles.textField}
                      value={parentInfo.content}
                      onChange={handleParentInputChange}
                      required
                    />
                  </div>
                </div>
              )}
              <div className={styles.r3}>
                <div className={styles.c2}>
                  <p>Start Date</p>
                  <input
                    type="date"
                    className={styles.textField}
                    name="start_date"
                    value={parentInfo.start_date}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
                <div className={styles.c2}>
                  <p>End Date</p>
                  <input
                    type="date"
                    name="end_date"
                    className={styles.textField}
                    value={parentInfo.end_date}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
              </div>
              <div className={styles.r3}>
                <div className={styles.c2}>
                  <p>Start Time</p>
                  <input
                    type="time"
                    name="start_time"
                    className={styles.textField}
                    value={parentInfo.start_time}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
                <div className={styles.c2}>
                  <p>End Time</p>
                  <input
                    type="time"
                    name="end_time"
                    className={styles.textField}
                    value={parentInfo.end_time}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
              </div>
              <div className={styles.r3}>
                <div className={styles.c2}>
                  <p>Display Interval</p>
                  <select
                    className={styles.intervals}
                    value={parentInfo.intervals}
                    onChange={handleParentInputChange}
                    name="intervals"
                    required
                  >
                    {options.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={styles.c2}>
                  <p>Time in hrs</p>
                  <input
                    type="number"
                    name="total_time"
                    className={styles.total}
                    value={parentInfo.total_time}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="MContactdetailSection open">
              <p
                className="MHeadings1"
                style={{ textAlign: "center", fontSize: "24px" }}
              >
                <b>Address Info</b>
              </p>

              <div className={styles.r3}>
                <div className={styles.c1}>
                  <p>House Number</p>
                  <input
                    type="text"
                    name="house_number"
                    className={styles.textField}
                    value={parentInfo.house_number}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
                <div className={styles.c2}>
                  <p>Street Number</p>
                  <input
                    type="text"
                    name="street_number"
                    className={styles.textField}
                    value={parentInfo.street_number}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
              </div>
              <div className="r4">
                <div className={styles.c1}>
                  <p>City</p>
                  <input
                    type="text"
                    name="city"
                    className={styles.textField}
                    value={parentInfo.city}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
                <div className={styles.c2}>
                  <p>Country</p>
                  <input
                    type="text"
                    name="country"
                    className={styles.textField}
                    value={parentInfo.country}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
              </div>
              <div className={styles.r2}>
                <div className={styles.c1}>
                  <p>Area</p>
                  <input
                    type="text"
                    name="area"
                    className={styles.textField}
                    value={parentInfo.area}
                    onChange={handleParentInputChange}
                    required
                  />
                </div>
                <div className={styles.c2}>
                  <p>Coordinates</p>
                  <input
                    type="text"
                    name="coordinates"
                    className={styles.textField}
                    value={parentInfo.coordinates}
                    onChange={handleParentInputChange}
                    required
                  />
                  <button type="button" onClick={geocodeAddress}>
                    Find Coordinates
                  </button>
                </div>
              </div>
              <div className={styles.mapContainer}>
                <MapContainer
                  center={mapCenter}
                  zoom={13}
                  style={{ height: "400px", width: "100%" }}
                  ref={mapRef}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  />
                  {marker && <Marker position={marker} />}
                  <SetViewOnClick coords={mapCenter} shouldPan={shouldPan} />
                  <MapEvents />
                </MapContainer>
              </div>
            </div>
            <div className="MContactdetailSection open">
              <p
                className="MHeadings1"
                style={{ textAlign: "center", fontSize: "24px" }}
              >
                <b>Slot Selection</b>
              </p>
              <select
                className={styles.slotOptions}
                value={selectedPage}
                onChange={(e) => {
                  setSelectedPage(e.target.value);
                  setSelectedSlot(null);
                }}
                name="slotPlace"
                required
              >
                {slotPlaceOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <div className={styles.preview}>
                {selectedPage === "landingPage" && (
                  <Preview
                    preview={
                      parentInfo.image
                        ? "image"
                        : parentInfo.video
                        ? "video"
                        : parentInfo.text
                        ? "text"
                        : "yes"
                    }
                    selectTheSlot={selectTheSlot}
                  />
                )}
                {selectedPage === "arenaHomePage" && (
                  <PreviewArena
                    preview={
                      parentInfo.image
                        ? "image"
                        : parentInfo.video
                        ? "video"
                        : parentInfo.text
                        ? "text"
                        : "yes"
                    }
                    selectTheSlot={selectTheSlot}
                  />
                )}
                {selectedPage === "arenaDetailPage" && (
                  <PreviewArenaDetail
                    preview={
                      parentInfo.image
                        ? "image"
                        : parentInfo.video
                        ? "video"
                        : parentInfo.text
                        ? "text"
                        : "yes"
                    }
                    selectTheSlot={selectTheSlot}
                  />
                )}
                {selectedPage === "newsHomePage" && (
                  <PreviewNewsHome
                    preview={
                      parentInfo.image
                        ? "image"
                        : parentInfo.video
                        ? "video"
                        : parentInfo.text
                        ? "text"
                        : "yes"
                    }
                    selectTheSlot={selectTheSlot}
                  />
                )}
                {selectedPage === "newsDetailPage" && (
                  <PreviewNewsDetail
                    preview={
                      parentInfo.image
                        ? "image"
                        : parentInfo.video
                        ? "video"
                        : parentInfo.text
                        ? "text"
                        : "yes"
                    }
                    selectTheSlot={selectTheSlot}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </form>
      {adButton === "watch" && (
        <div className={styles.adlist}>
          <div className={styles.tablead}>
            <table>
              <thead>
                <tr>
                  <th>id</th>
                  <th>Company</th>
                  <th>Agency</th>
                  <th>Clicks</th>
                  <th>Slot</th>
                  <th>Start</th>
                  <th>End</th>
                  <th>TimeSpan</th>
                  <th>Time Remaining</th>
                  <th>Content</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ads.length > 0 ? (
                  ads.length > 0 &&
                  ads.map((ad) => (
                    <tr key={ad.ids}>
                      <td>
                        {ad.ids}
                        {isAdCurrentlyActive(ad) && (
                          <>
                            <span
                              style={{
                                display: "inline-block",
                                width: "6px",
                                height: "6px",
                                borderRadius: "50%",
                                backgroundColor: "#22c55e",
                                marginLeft: "6px",
                                verticalAlign: "middle",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></span>
                            <style>
                              {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.3); opacity: 0.7; }
            100% { transform: scale(1); opacity: 1; }
          }
        `}
                            </style>
                          </>
                        )}
                      </td>
                      <td>{ad.company}</td>
                      <td>{ad.agency}</td>
                      <td>{ad.clicks}</td>
                      <td>{ad.slotPlace}</td>
                      <td>{formatDate(ad.start_date)}</td>
                      <td>{formatDate(ad.end_date)}</td>
                      <td>
                        {formatTime(ad.start_time)} - {formatTime(ad.end_time)}
                      </td>
                      <td>{ad.total_time} sec</td>
                      <td>
                        <span>
                          {ad.image ? (
                            <img
                              src={ad.image}
                              alt={ad.ids}
                              style={{
                                width: "50px",
                                height: "50px",
                                cursor: "pointer",
                                border: "1px solid grey",
                              }}
                            />
                          ) : ad.video ? (
                            <video
                              src={ad.video}
                              alt={ad.ids}
                              style={{
                                width: "50px",
                                height: "50px",
                                cursor: "pointer",
                                border: "1px solid grey",
                              }}
                            />
                          ) : (
                            ad.text.split("\n")[0]
                          )}
                        </span>
                      </td>
                      <td>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(ad.ids);
                          }}
                          className={styles.btn}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>no ads</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
